<div class="main-container" style="width: 100%;"
  [style.width.px]="dataFormItem.cfgDFormItem.ParagraphColumnWidth > 0 ? dataFormItem.cfgDFormItem.ParagraphColumnWidth : 'fit-content'"
  [class.side-by-side]="sideBySide"
  data-cy="forms-item-container">
  <div *ngIf="formsGlobals.CONTROL_TEXT_AREA== dataFormItem.cfgDFormItem.enumFormControlID" class="control-item"
       data-cy="forms-item-text-area">
    <mat-form-field class="full-width" matAutosize="true" matTextareaAutosize="true" matAutosizeMinRows="20"
      cdkTextareaAutosize="true" cdkAutosizeMinRows="20"
      data-cy="forms-item-text-area-field">
      <textarea [disabled]="isLocked" class="full-width text-area-item" matInput
        placeholder="{{ dataFormItem.cfgDFormItem.Label }}"
        [style.height.px]="dataFormItem.cfgDFormItem.ParagraphRowHeight - 50"
        [required]="dataFormItem.cfgDFormItem.isRequired" [style.font-size.px]="dataFormItem.cfgDFormItem.DefaultValue"
        [(ngModel)]="dataFormItem.RESULT.Result"
        data-cy="forms-item-text-area-input"></textarea>
    </mat-form-field>
  </div>

  <div *ngIf="formsGlobals.CONTROL_TEXT_BOX  == dataFormItem.cfgDFormItem.enumFormControlID && dataFormItem.RESULT"
    class="control-item"
    data-cy="forms-item-text-box">
    <div class="required-symbol required-signature"
      *ngIf="dataFormItem.cfgDFormItem.isRequired === true && (dataFormItem.RESULT?.Result === null || dataFormItem.RESULT?.Result === '')"
      data-cy="forms-item-text-box-required"> * </div>
    <mat-form-field class="full-width" data-cy="forms-item-text-box-field">
      <input class="full-width" [disabled]="isLocked" (appInputFinished)="onTextInputFinished($event)" matInput
        [required]="dataFormItem.cfgDFormItem.isRequired" placeholder="{{ dataFormItem.cfgDFormItem.Label }}"
        [(ngModel)]="dataFormItem.RESULT.Result"
        data-cy="forms-item-text-box-input">
    </mat-form-field>
  </div>

  <div *ngIf="showPad && formsGlobals.CONTROL_SIGNATURE == dataFormItem.cfgDFormItem.enumFormControlID"
       data-cy="forms-item-signature">
    <div #signatureContainer class="signature-container" [style.width.px]="signaturePadOptions.canvasWidth"
      [style.height.px]="100" 
      data-cy="forms-item-signature-container">
      <div class="signature-placeholder" *ngIf="resetSignature" data-cy="forms-item-signature-placeholder">Sign here</div>
      <signature-pad #signaturePad [options]="signaturePadOptions"
      (onBeginEvent)="signatureDrawStart()"
        *ngIf="dataFormItem.RESULT?.Result == '' || resetSignature"
        data-cy="forms-item-signature-pad">
      </signature-pad>
      <div class="required-symbol required-signature" *ngIf="dataFormItem.cfgDFormItem.isRequired === true && resetSignature && !isLocked" data-cy="forms-item-signature-required">*</div>
      <img *ngIf="dataFormItem.RESULT?.Result && dataFormItem.RESULT?.Result != '' && !resetSignature"
        [style.width.px]="signaturePadOptions.canvasWidth"
        [style.height.px]="100"
        src="{{dataFormItem.RESULT?.Result}}" alt="Signature"  
        data-cy="forms-item-signature-image"/>
      <div class="signature-button" *ngIf="!isLocked" data-cy="forms-item-signature-button-container">
        <mat-icon (click)="clearSignature()" *ngIf="!resetSignature" [style.display]="resetSignature ? 'none' : ''" data-cy="forms-item-signature-clear">close</mat-icon>
        <button (click)="signName()" *ngIf="resetSignature && currentPatientName !== ''" [style.display]="resetSignature ? '' : 'none'" 
          class="tdo-button tdo-save" style="margin-top: 0px; margin-right: 10px;height:25px;padding:0px 10px 0px 10px" data-cy="forms-item-signature-sign-name-button">Sign with Name</button>
          <button (click)="signatureDrawComplete()" *ngIf="resetSignature" [style.display]="resetSignature ? '' : 'none'" 
          class="tdo-button tdo-save" style="margin-top: 0px;height:25px;padding:0px" data-cy="forms-item-signature-sign-button">Sign</button>
      </div>
    </div>
  </div>

  <div class="heading" *ngIf="formsGlobals.CONTROL_HEADING == dataFormItem.cfgDFormItem.enumFormControlID"
    [style.text-align]="getTextAlign(dataFormItem)"
    data-cy="forms-item-heading">
    <p class="heading-content" data-cy="forms-item-heading-content">{{ dataFormItem.cfgDFormItem.Label }}</p>
  </div>

  <div class="heading"
    *ngIf="formsGlobals.CONTROL_GROUP_HEADING_WITH_SUMMARY == dataFormItem.cfgDFormItem.enumFormControlID"
    data-cy="forms-item-group-heading">
    <button mat-button class="tdo-button primary-accent" *ngIf="!isPatient" (click)="openSummaryWindow()"
            data-cy="forms-item-summary-button">Open summary</button>
  </div>

  <div *ngIf="formsGlobals.CONTROL_SPACER == dataFormItem.cfgDFormItem.enumFormControlID"
       data-cy="forms-item-spacer">
  </div>

  <div *ngIf="formsGlobals.CONTROL_RADIO_LIST == dataFormItem.cfgDFormItem.enumFormControlID"
    class="control-item radio-control-container"
    data-cy="forms-item-radio-list">
    <div class="required-symbol" *ngIf="dataFormItem.cfgDFormItem.isRequired === true && dataFormItem.RESULT?.Result === null"
         data-cy="forms-item-radio-required"> * </div>
    <mat-radio-group aria-label="Select an option" name="{{dataFormItem.DFormItemId}}" [disabled]="isLocked"
      *ngIf="dataFormItem.cfgDFormItem && dataFormItem.cfgDFormItem.ValidValue"
      [required]="dataFormItem.cfgDFormItem.isRequired"
      data-cy="forms-item-radio-group">
      <mat-radio-button class="radio-button" [disabled]="isLocked"
        *ngFor="let option of dataFormItem.cfgDFormItem.ValidValue.enumValidValueItems; let i = index"
        [checked]="dataFormItem?.RESULT?.Result === option.ValidValueItemId" (click)="setSingleResult(option)"
        name="{{dataFormItem.DFormItemId}}{{ option.ItemDisplayValue }}" value="{{ option.ValidValueItemId }}"
        data-cy="forms-item-radio-option-{{i}}">
        {{ option.ItemDisplayValue }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div *ngIf="formsGlobals.CONTROL_CHECK_BOX_LIST == dataFormItem.cfgDFormItem.enumFormControlID" class="control-item"
       data-cy="forms-item-checkbox-list">
    <div style="display: flex; flex-wrap: wrap;"
      *ngIf="dataFormItem.cfgDFormItem && dataFormItem.cfgDFormItem.ValidValue"
      data-cy="forms-item-checkbox-container">
      <div class="required-symbol"
        *ngIf="dataFormItem.cfgDFormItem.isRequired === true && dataFormItem?.RESULT === null"
        style="position: relative;top: 0px;"
        data-cy="forms-item-checkbox-required"> * </div>
      <div style="margin-left: 4px;" *ngFor="let option of dataFormItem.cfgDFormItem.ValidValue.enumValidValueItems; let i = index"
           data-cy="forms-item-checkbox-item-{{i}}">
        <mat-checkbox class="checkbox-button" [disabled]="isLocked"
          (click)="setMultiResult(option, checkIfOptionIsInResult(option))"
          [checked]="dataFormItem?.RESULT?.Result === option.ValidValueItemId"
          data-cy="forms-item-checkbox-{{i}}">
          {{ option.ItemDisplayValue }}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div *ngIf="formsGlobals.CONTROL_LABEL == dataFormItem.cfgDFormItem.enumFormControlID"
    [style.text-align]="getTextAlign(dataFormItem)"
    data-cy="forms-item-label">
    <p class="label-content" data-cy="forms-item-label-content">{{ dataFormItem.cfgDFormItem.Label }}</p>
  </div>

  <div *ngIf="formsGlobals.CONTROL_CHECK_BOX == dataFormItem.cfgDFormItem.enumFormControlID" class="checkbox-control"
       data-cy="forms-item-checkbox">
    <mat-checkbox (change)="onCheckBoxClick($event)" [disabled]="isLocked"
      [checked]="dataFormItem.RESULT?.Result === 'true'"
      data-cy="forms-item-single-checkbox">
      {{ dataFormItem.cfgDFormItem.Label }}
    </mat-checkbox>
  </div>

  <div *ngIf="formsGlobals.CONTROL_NUMERIC_SLIDER == dataFormItem.cfgDFormItem.enumFormControlID"
       data-cy="forms-item-slider">
    <mat-slider [disabled]="isLocked" class="full-width" [(ngModel)]="dataFormItem.RESULT.NumResult"
      [thumbLabel]="true" data-cy="forms-item-slider-control"><input matSliderThumb data-cy="forms-item-slider-thumb" />
    </mat-slider>
  </div>

  <div *ngIf="formsGlobals.CONTROL_NUMERIC_INTEGER == dataFormItem.cfgDFormItem.enumFormControlID"
    class="form-integer-control"
    data-cy="forms-item-numeric-integer">
    <mat-form-field floatLabel="never" data-cy="forms-item-numeric-integer-field">
      <input matInput type="number" [required]="dataFormItem?.cfgDFormItem?.isRequired"
        placeholder="{{ dataFormItem.cfgDFormItem.Label || 'Enter a number' }}" step="1"
        [value]="dataFormItem.RESULT?.Result" [disabled]="isLocked"
        (change)="onNumericInputChange($event, dataFormItem)"
        data-cy="forms-item-numeric-integer-input">
    </mat-form-field>
  </div>

  <div *ngIf="formsGlobals.CONTROL_NUMERIC_DECIMAL == dataFormItem.cfgDFormItem.enumFormControlID"
       data-cy="forms-item-numeric-decimal">
    <mat-form-field data-cy="forms-item-numeric-decimal-field">
      <input matInput [required]="dataFormItem.cfgDFormItem.isRequired" type="number"
        placeholder="{{ dataFormItem.cfgDFormItem.Label || 'Enter a number' }}"
        (appInputFinished)="onTextInputFinished($event)" [disabled]="isLocked" [(ngModel)]="dataFormItem.RESULT.Result"
        data-cy="forms-item-numeric-decimal-input">
    </mat-form-field>
  </div>

  <div *ngIf="formsGlobals.CONTROL_DATE == dataFormItem.cfgDFormItem.enumFormControlID"
       data-cy="forms-item-date">
    <mat-form-field style="width: 100%;" data-cy="forms-item-date-field">
      <input [disabled]="isLocked" matInput [required]="dataFormItem.cfgDFormItem.isRequired" [matDatepicker]="picker"
        [(ngModel)]="dataFormItem.RESULT.Result" (appInputFinished)="onTextInputFinished($event)"
        placeholder="{{ dataFormItem.cfgDFormItem.Label || 'Choose a date' }}"
        data-cy="forms-item-date-input" />
      <mat-datepicker-toggle (change)="onDatePickerChange($event)" [disabled]="isLocked" matSuffix
        [for]="picker" data-cy="forms-item-date-toggle"></mat-datepicker-toggle>
      <mat-datepicker (closed)="onDatePickerClosed($event)" #picker data-cy="forms-item-date-picker"></mat-datepicker>
    </mat-form-field>
  </div>

  <div *ngIf="formsGlobals.CONTROL_TIME == dataFormItem.cfgDFormItem.enumFormControlID"
       data-cy="forms-item-time">
    <mat-form-field class="date-form-hour" data-cy="forms-item-time-hour-field">
      <input matInput type="number" [required]="dataFormItem.cfgDFormItem.isRequired" placeholder="Hours" [max]="23"
        [min]="0" [(ngModel)]="dataFormItem.RESULT_HOUR" (change)="validateTime('hours')" [disabled]="isLocked"
        (ngModelChange)="validateTime('hours');updateItemDate('hours')"
        data-cy="forms-item-time-hour-input">
    </mat-form-field>
    <mat-form-field class="date-form-minute" data-cy="forms-item-time-minute-field">
      <input matInput type="number" placeholder="Minutes" [max]="59" [required]="dataFormItem.cfgDFormItem.isRequired"
        [min]="0" [(ngModel)]="dataFormItem.RESULT_MINUTES" (change)="validateTime('minutes')" [disabled]="isLocked"
        (ngModelChange)="validateTime('minutes');updateItemDate('minutes')"
        data-cy="forms-item-time-minute-input">
    </mat-form-field>
  </div>

  <div *ngIf="formsGlobals.CONTROL_DATE_TIME == dataFormItem.cfgDFormItem.enumFormControlID"
       data-cy="forms-item-date-time">
    <mat-form-field class="date-form-field" data-cy="forms-item-date-time-date-field">
      <input matInput [matDatepicker]="picker" [required]="dataFormItem.cfgDFormItem.isRequired"
        [(ngModel)]="dataFormItem.RESULT.Result" [disabled]="isLocked"
        (ngModelChange)="formatDateTime(); updateItemDate('hours'); updateItemDate('minutes')"
        placeholder="{{ dataFormItem.cfgDFormItem.Label || 'Choose a date' }}"
        data-cy="forms-item-date-time-date-input" />
      <mat-datepicker-toggle [disabled]="isLocked" matSuffix [for]="picker" data-cy="forms-item-date-time-toggle"></mat-datepicker-toggle>
      <mat-datepicker #picker data-cy="forms-item-date-time-picker"></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="date-form-hour" data-cy="forms-item-date-time-hour-field">
      <input matInput type="number" placeholder="Hours" [required]="dataFormItem.cfgDFormItem.isRequired" [max]="23"
        [min]="0" [(ngModel)]="dataFormItem.RESULT_HOUR" [disabled]="!dataFormItem.RESULT.Result || isLocked"
        (change)="validateTime('hours')" (ngModelChange)="validateTime('hours');updateItemDate('hours')"
        data-cy="forms-item-date-time-hour-input">
    </mat-form-field>
    <mat-form-field class="date-form-minute" data-cy="forms-item-date-time-minute-field">
      <input matInput type="number" placeholder="Minutes" [max]="59" [required]="dataFormItem.cfgDFormItem.isRequired"
        [min]="0" [(ngModel)]="dataFormItem.RESULT_MINUTES" [disabled]="!dataFormItem.RESULT.Result || isLocked"
        (change)="validateTime('minutes')" (ngModelChange)="validateTime('minutes');updateItemDate('minutes')"
        data-cy="forms-item-date-time-minute-input">
    </mat-form-field>
  </div>

  <div *ngIf="formsGlobals.CONTROL_COMBO_LIST == dataFormItem.cfgDFormItem.enumFormControlID"
    class="form-combobox-control"
    [ngClass]="{'form-combobox-control-small': dataFormItem.cfgDFormItem.ParagraphRowHeight < 30}" style="height: 100%"
    data-cy="forms-item-combo-list">
    <mat-form-field class="dropdown-form-field" [floatLabel]="getFloatLabelValue()" [style.height.pct]="100"
      style="overflow-y: hidden; width: 100%;" data-cy="forms-item-combo-list-field">
      <mat-label data-cy="forms-item-combo-list-label">
        {{ getDisplayNameForItemResult() || "Please select a value" }}
      </mat-label>
      <mat-select [disabled]="isLocked" [value]="dataFormItem.RESULT?.Result"
        [required]="dataFormItem.cfgDFormItem.isRequired"
        (selectionChange)="onComboListSelectionChange($event, dataFormItem)"
        data-cy="forms-item-combo-list-select">
        <mat-option [disabled]="isLocked" [value]="validValueItem" *ngFor="let validValueItem of getValidValueItems(); let i = index"
                    data-cy="forms-item-combo-list-option-{{i}}">
          {{ validValueItem.ItemDisplayValue }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="formsGlobals.CONTROL_CURRENCY == dataFormItem.cfgDFormItem.enumFormControlID"
       data-cy="forms-item-currency">
    <mat-form-field data-cy="forms-item-currency-field">
      <input matInput [disabled]="isLocked" type="number" [required]="dataFormItem.cfgDFormItem.isRequired"
        placeholder="{{ dataFormItem.cfgDFormItem.Label || 'Enter a currency amount' }}" min="0.01" step="0.01"
        [disabled]="isLocked" [(ngModel)]="dataFormItem.RESULT.Result"
        data-cy="forms-item-currency-input">
    </mat-form-field>
  </div>

  <div *ngIf="formsGlobals.CONTROL_AUTOFILL_FORM == dataFormItem.cfgDFormItem.enumFormControlID"
       data-cy="forms-item-autofill">
    CONTROL_AUTOFILL_FORM
  </div>

  <div *ngIf="formsGlobals.CONTROL_BLOOD_PRESSURE == dataFormItem.cfgDFormItem.enumFormControlID"
       data-cy="forms-item-blood-pressure">
    <mat-form-field data-cy="forms-item-blood-pressure-systolic-field">
      <input matInput [required]="dataFormItem.cfgDFormItem.isRequired" type="number" placeholder="Systolic" step="1"
        [disabled]="isLocked" [(ngModel)]="dataFormItem.RESULT_TOP" (change)="updateBloodPressure()"
        (ngModelChange)="updateBloodPressure()"
        data-cy="forms-item-blood-pressure-systolic-input">
    </mat-form-field>
    <mat-form-field data-cy="forms-item-blood-pressure-diastolic-field">
      <input matInput type="number" [required]="dataFormItem.cfgDFormItem.isRequired" placeholder="Diastolic" step="1"
        [(ngModel)]="dataFormItem.RESULT_BOTTOM" (change)="updateBloodPressure()" [disabled]="isLocked"
        (ngModelChange)="updateBloodPressure()"
        data-cy="forms-item-blood-pressure-diastolic-input">
    </mat-form-field>
  </div>

  <div *ngIf="formsGlobals.CONTROL_VITAL_SIGNS == dataFormItem.cfgDFormItem.enumFormControlID">
    <mat-form-field>
      <input matInput type="number" placeholder="" [required]="dataFormItem.cfgDFormItem.isRequired" step="1"
        [(ngModel)]="dataFormItem.RESULT_VITAL_ONE" (change)="updateVitalSigns()" [disabled]="isLocked"
        (ngModelChange)="updateVitalSigns()">
    </mat-form-field>
    <mat-form-field>
      <input matInput type="number" placeholder="" [required]="dataFormItem.cfgDFormItem.isRequired" step="1"
        [(ngModel)]="dataFormItem.RESULT_VITAL_TWO" (change)="updateVitalSigns()" [disabled]="isLocked"
        (ngModelChange)="updateVitalSigns()">
    </mat-form-field>
    <mat-form-field>
      <input matInput type="number" placeholder="" [required]="dataFormItem.cfgDFormItem.isRequired" step="1"
        [(ngModel)]="dataFormItem.RESULT_VITAL_THREE" (change)="updateVitalSigns()" [disabled]="isLocked"
        (ngModelChange)="updateVitalSigns()">
    </mat-form-field>
  </div>

  <div *ngIf="formsGlobals.CONTROL_LABEL_45 == dataFormItem.cfgDFormItem.enumFormControlID"
    [style.text-align]="getTextAlign(dataFormItem)">
    <p class="label-45-content">{{ dataFormItem.cfgDFormItem.Label }}</p>
  </div>

  <div *ngIf="formsGlobals.CONTROL_TOOTH_PICKER == dataFormItem.cfgDFormItem.enumFormControlID">
    <div *ngIf="dataFormItem.cfgDFormItem && dataFormItem.cfgDFormItem.ValidValue">
      <div class="checkbox-button-container"
        *ngFor="let option of dataFormItem.cfgDFormItem.ValidValue.enumValidValueItems">
        <mat-checkbox class="checkbox-button" *ngIf="checkIfOptionIsInResult(option)"
          (click)="setMultiResult(option, true)" [disabled]="isLocked" [checked]="true"> 
          {{ option.ItemDisplayValue }}
        </mat-checkbox>
        <mat-checkbox class="checkbox-button" *ngIf="!checkIfOptionIsInResult(option)"
          (click)="setMultiResult(option, false)" [disabled]="isLocked" [checked]="false">
          {{ option.ItemDisplayValue }}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div *ngIf="formsGlobals.CONTROL_ACTION_BUTTON == dataFormItem.cfgDFormItem.enumFormControlID && !isLocked" class="control-item form-item-action-button" >

    <button *ngIf="dataFormItem.cfgDFormItem.AfterUpdateItemAction.ActionName == FormActionNameEnum.REPEAT_PARAGRAPH" [disabled]="isLocked" style="margin-right: 10px;"
      mat-button class="tdo-button tdo-save form-item-action-button-delete" (click)="deleteParagraph(dataFormItem.dataFormParagraphID)">Delete
    </button>
    <button [disabled]="isLocked" mat-button class="tdo-button tdo-save form-item-action-button-perform" (click)="performActionFromButton()">{{dataFormItem.cfgDFormItem.Label}}
    </button>
  </div>

  <div [style.height.px]="dataFormItem.cfgDFormItem.ParagraphRowHeight"
    style="font-size: 16px; background-color: var(--tdo-primary); color: white; border-top-left-radius: 8px; border-top-right-radius: 8px; padding-left: 6px;"
    class="row-header" *ngIf="formsGlobals.CONTROL_ROW_HEADER == dataFormItem.cfgDFormItem.enumFormControlID">
    <!--{{ dataFormItem.cfgDFormItem.Label }}-->
    <span style="position: relative; top: calc(50% - 10px);">{{ getRowHeaderLabelOrResult() }}</span>
  </div>

  <div *ngIf="formsGlobals.CONTROL_SMALL_CHECK_BOX == dataFormItem.cfgDFormItem.enumFormControlID" class="control-item">
    <mat-checkbox class="checkbox-button" [required]="dataFormItem.cfgDFormItem.isRequired"
      *ngIf="dataFormItem.RESULT?.Result === 'true'" (click)="setAbsoluteSingleResult('false')" [disabled]="isLocked"
      [checked]="true">
      {{ dataFormItem.cfgDFormItem.Label }}
    </mat-checkbox>
    <mat-checkbox class="checkbox-button" [required]="dataFormItem.cfgDFormItem.isRequired"
      *ngIf="dataFormItem.RESULT?.Result !== 'true'" (click)="setAbsoluteSingleResult('true')" [disabled]="isLocked"
      [checked]="false">
      {{ dataFormItem.cfgDFormItem.Label }}
    </mat-checkbox>
  </div>

  <div *ngIf="formsGlobals.CONTROL_NUMERIC_DRAG_INPUT_SLIDER == dataFormItem.cfgDFormItem.enumFormControlID"
    class="control-item">
    <mat-slider [disabled]="isLocked" class="full-width" [(ngModel)]="dataFormItem.RESULT.NumResult"
      [thumbLabel]="true"><input matSliderThumb />
    </mat-slider>
  </div>

  <div *ngIf="formsGlobals.CONTROL_BULLETPOINT == dataFormItem.cfgDFormItem.enumFormControlID" class="control-item">
    <ul [style.font-size.px]="dataFormItem.cfgDFormItem.DefaultValue">
      <li *ngFor="let option of dataFormItem.cfgDFormItem.ValidValue.enumValidValueItems"
        [style.font-size.px]="dataFormItem.cfgDFormItem.DefaultValue">{{ option.ItemDisplayValue }}</li>
    </ul>
  </div>

  <div *ngIf="formsGlobals.CONTROL_HIDDENINPUT == dataFormItem.cfgDFormItem.enumFormControlID" class="control-item">
    <mat-form-field>
      <input class="full-width hidden-input" matInput data-lpignore="true" autocomplete="off"
        [required]="dataFormItem.cfgDFormItem.isRequired" *ngIf="!showHiddenText" type="password"
        placeholder="{{ dataFormItem.cfgDFormItem.Label }}" [(ngModel)]="dataFormItem.RESULT.Result">
      <input class="full-width hidden-input" matInput *ngIf="showHiddenText" autocomplete="off"
        [required]="dataFormItem.cfgDFormItem.isRequired" type="text"
        placeholder="{{ dataFormItem.cfgDFormItem.Label }}" [(ngModel)]="dataFormItem.RESULT.Result">
    </mat-form-field>
    <button mat-button class="tdo-button primary-accent hide-text-button" (click)="showHiddenText = !showHiddenText">
      <i class="material-icons" *ngIf="!showHiddenText">visibility</i>
      <i class="material-icons" *ngIf="showHiddenText">visibility_off</i>
    </button>
  </div>

  <div *ngIf="formsGlobals.CONTROL_MARKUP == dataFormItem.cfgDFormItem.enumFormControlID" class="control-item">
    <div [innerHTML]="dataFormItem.cfgDFormItem.Label" [style.font-size.px]="dataFormItem.cfgDFormItem.DefaultValue">
    </div>
  </div>

  <div *ngIf="formsGlobals.CONTROL_PHONE == dataFormItem.cfgDFormItem.enumFormControlID" class="control-item">
    <mat-form-field class="full-width">
      <mat-label>{{ dataFormItem.cfgDFormItem.Label }}</mat-label>
      <input matInput [required]="dataFormItem.cfgDFormItem.isRequired" (ngModelChange)="phoneInputChanged($event);"
        [disabled]="isLocked" [(ngModel)]="dataFormItem.RESULT.Result">
    </mat-form-field>
  </div>

  <div style="display: flex; flex-direction: row; margin-top: 10px;"
    *ngIf="dataFormItem.cfgDFormItem.enumFormControlID === formsGlobals.CONTROL_MACRO_NOTES_DROPDOWN && dataNoteSet">
    <mat-form-field floatLabel="never" class="dropdown-form-field" style="overflow-y: hidden; margin-right: 2px;">
      <mat-select [disabled]="isLocked" [placeholder]="dataFormItem.cfgDFormItem.Label"
        (selectionChange)="onMacroNoteSelection($event)">
        <mat-option [disabled]="isLocked" [value]="note" *ngFor="let note of dataNoteSet.dataPredefinedNotes">
          {{ note.NoteDescription }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button [disabled]="!selectedPredefinedNote || isLocked" style="margin: 2px; margin-left: 8px;"
      (click)="onCreateNoteClick()" class="tdo-button primary-accent">
      Create Note
    </button>
  </div>

  <ng-container *ngIf="dataFormItem.cfgDFormItem.enumFormControlID === formsGlobals.CONTROL_IMAGE_LIST">
    <div style="display: flex; flex-direction: column" [style.height.px]="dataFormItem.cfgDFormItem.ParagraphRowHeight"
      [style.width.px]="dataFormItem.cfgDFormItem.ParagraphColumnWidth - 10">
      <div class="header" style="flex-basis: 30px; min-height: 30px; text-align: left;">
        <span
          style="flex: 1; color: white; margin-left: 8px; font-weight: 400; position: relative; top: 8px; font-size: 16px;">{{dataFormItem.cfgDFormItem.Label}}</span>
        <span style="color: white; flex-basis: 26px; position: relative; top: 4px; cursor: pointer;"
          (click)="onAddImageClick()"><mat-icon>add_circle_outline</mat-icon></span>
      </div>
      <div id="image-holder" appDragFileToBrowser (files)="filesDropped($event)" style="overflow: hidden;"
        [style.height.px]="dataFormItem.cfgDFormItem.ParagraphRowHeight">
        <app-tdo-progress-spinner *ngIf="isUploading"
          style="position: absolute; top: 50%; left: calc(50% - 40px);"></app-tdo-progress-spinner>
        <input #fileInput type="file" style="display: none;" accept="image/jpg, image/png" (change)="onImageSelected()">
        <div *ngIf="!dataFormItem.dataFormResults || dataFormItem.dataFormResults.length == 0"
          (click)="onAddImageClick()"
          style="color: white; margin-left: auto; margin-right: auto; position: relative; top: 46%; width: fit-content;">
          Click or drag and drop to add image</div>
        <div *ngIf="dataFormItem.dataFormResults"
          style="display: flex; overflow-x: scroll; overflow-y: hidden; max-width: calc(100%); height: calc(100%);">
          <div *ngFor="let result of dataFormItem.dataFormResults" style="position: relative; width: fit-content;">
            <img (click)="onImageListClick(result)" style="margin: 4px;" alt="Form Item"
              [src]="fileService.getPatientDocumentUrl(patientId, result.Result)">
            <span (click)="deleteImageListItem(result)"
              style="color: red; position: absolute; top: 4px; right: 4px;"><mat-icon>delete</mat-icon></span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

</div>
